import { useState, useCallback, useEffect } from "react";
import { API_BASE } from "../config";
import type { PhotoItem } from "../types";

export function usePhotos() {
  const [photos, setPhotos] = useState<PhotoItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [deletingId, setDeletingId] = useState<string | null>(null);

  const fetchPhotos = useCallback((skipLoading = false) => {
    if (!skipLoading) setLoading(true);
    setError(null);
    fetch(`${API_BASE}/api/photos`, { credentials: "include" })
      .then((res) => {
        if (!res.ok) throw new Error("Fotos konnten nicht geladen werden");
        return res.json() as Promise<PhotoItem[]>;
      })
      .then(setPhotos)
      .catch((e) => setError(e instanceof Error ? e.message : "Fehler"))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    fetchPhotos();
  }, [fetchPhotos]);

  const deletePhoto = useCallback(
    async (id: string) => {
      setDeletingId(id);
      try {
        const res = await fetch(`${API_BASE}/api/photos/${id}`, {
          method: "DELETE",
          credentials: "include",
        });
        if (res.ok) fetchPhotos(true);
      } finally {
        setDeletingId(null);
      }
    },
    [fetchPhotos]
  );

  return { photos, loading, error, fetchPhotos, deletePhoto, deletingId };
}
